import type { ResourceUpdatedPayload } from '@cotera/api';

export type AgentNodeWireDisplay = {
  editorState: unknown;
  agentKey: string;
  model: string;
  description: string | null;
};

export function agentNodeDisplayFromWireAgent(agent: {
  editorState: unknown;
  agentKey: string;
  model: string;
  description?: string | null;
}): AgentNodeWireDisplay {
  return {
    editorState: agent.editorState,
    agentKey: agent.agentKey,
    model: agent.model,
    description: agent.description ?? null,
  };
}

/** Live chrome fields from an augmented agent `ResourceUpdated` payload. */
export function agentNodeDisplayFromResourceUpdatedPayload(
  payload: ResourceUpdatedPayload | undefined
): AgentNodeWireDisplay | null {
  if (payload?.resourceType !== 'agent' || payload.agent === undefined) {
    return null;
  }
  return agentNodeDisplayFromWireAgent(payload.agent);
}
